import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  large: {
    fontSize: '1.1rem',
    margin: '10px 0'
  },
  text: {
    fontSize: '.9rem',
    margin: '5px 0'
  },
  details: {
    fontWeight: '300',
    marginBottom: '15px'
  }
});
